import { Loader2 } from "lucide-react";

export const Loading = ({ label = "Cargando…" }) => (
  <div className="flex items-center gap-3 py-16 text-muted-foreground" data-testid="loading-state">
    <Loader2 className="h-5 w-5 animate-spin" />
    <span className="text-sm">{label}</span>
  </div>
);

export const PageTitle = ({ title, subtitle, children, testId }) => (
  <div className="mb-8 flex flex-wrap items-end justify-between gap-4 rise" data-testid={testId}>
    <div>
      <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight">{title}</h1>
      {subtitle && <p className="mt-2 max-w-2xl text-sm text-muted-foreground leading-relaxed">{subtitle}</p>}
    </div>
    {children}
  </div>
);

export const Stat = ({ label, value, hint, tone = "default", icon: Icon, testId }) => {
  const tones = {
    default: "text-foreground",
    good: "text-primary",
    warn: "text-accent",
    bad: "text-destructive",
  };
  return (
    <div className="lift rounded-lg border border-border/60 bg-card p-6" data-testid={testId}>
      <div className="flex items-center justify-between">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-muted-foreground">{label}</p>
        {Icon && <Icon className="h-4 w-4 text-muted-foreground" />}
      </div>
      <p className={`mt-4 font-display text-2xl sm:text-3xl font-extrabold tracking-tight ${tones[tone]}`}>{value}</p>
      {hint && <p className="mt-2 text-xs text-muted-foreground">{hint}</p>}
    </div>
  );
};

export const Empty = ({ children, testId }) => (
  <div className="rounded-lg border border-dashed border-border bg-card/50 p-10 text-center text-sm text-muted-foreground"
       data-testid={testId}>
    {children}
  </div>
);
